import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import UseWindowSize from 'flaivy-react/hooks/UseWindowSize';
import Swiper from './Swiper';

export default function SwiperBannerComponent({ key = 'id', value = {} }) {
  const [data, setData] = useState([]);
  const { items = [], show = true } = value;

  const windowSize = UseWindowSize();

  const getData = () =>
    items.map(x => {
      const size =
        windowSize.bootstrapSize === 'xl'
          ? 'Large'
          : windowSize.bootstrapSizeFull;
      return {
        ...x,
        img: x[`image${size}`],
      };
    });

  useEffect(() => {
    setData(getData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [windowSize.bootstrapSizeFull, windowSize.bootstrapSize]);

  return (
    <>
      {show && (
        <Swiper
          key={key}
          data={data}
          autoplay
          autoplayDelay={5000}
          loop
          slidesPerView={1}
          spaceBetween={0}
          centeredSlides
          speed={1500}
          parallax
          navigation
          pagination
          style={{ height: '25vh', minHeight: '500px' }}
        />
      )}
    </>
  );
}

SwiperBannerComponent.propTypes = {
  value: PropTypes.object.isRequired,
};
